import React from 'react';
import OtherService from '../../service/OtherService/OtherService';

import {Select} from 'antd';
const { Option } = Select;
class BottomBar extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
           options: []
        };
    }
    public componentDidMount(): void {
        this.getOption();
    }
    public async getOption() {
        const USERINFO  = JSON.parse(localStorage.getItem('USERINFO'))
       const data =  await OtherService.getGroupList(USERINFO.leg);
       this.setState({
           options: data
       });
    }
    public render() {
        const { options } = this.state;
        return (
            <Select style={{ width: '200px' }}  {...this.props} value={this.props.value||undefined} placeholder='请选择' allowClear>
                {options.map(item => {
                    return(
                        // @ts-ignore
                        <Option key={item.groupId} value={item.groupId+""}>{item.name}</Option>
                    );
                })}
            </Select>
        );
    }

}
export default BottomBar;
